import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/puzzle-game",
    name: "puzzle-game",
    component: () =>
      import(
        /* webpackChunkName: "puzzle-game" */ "../views/PuzzleGameView.vue"
      ),
  },
  {
    path: "/dots-boxes",
    name: "dots-boxes",
    component: () =>
      import(/* webpackChunkName: "dots-boxes" */ "../views/DotsBoxesView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
